import { SelectSearch } from './SelectSearch'
import { withSelectSearch } from './withSelectSearch'

const ConnectedSelectSearch = withSelectSearch(SelectSearch)
export { ConnectedSelectSearch as SelectSearch }
